(function () {
  const Core = window.RB.Core;
  const Play = window.RB.Play;

  function nm(state, iid) {
    try { return Core.name(state, iid); } catch (e) { return "that card"; }
  }

  Object.assign(Play, {
    playOrigin(state, p, iid) {
      const o = state.objs[iid];
      if (!o) return null;
      const pl = state.players[p];
      if (o.zone === "hand" && pl.hand.indexOf(iid) >= 0) return { fromZone: "hand", hiddenBf: null };
      if (o.zone === "champion" && pl.champion.indexOf(iid) >= 0) return { fromZone: "champion", hiddenBf: null };
      if (o.zone === "facedown") {
        return { fromZone: "facedown", hiddenBf: RB.Flow.hiddenBfOf(state, iid) };
      }
      if (o.zone === "trash" && pl.trash.indexOf(iid) >= 0) return { fromZone: "trash", hiddenBf: null };
      return null;
    },

    playCost(state, p, iid, origin) {
      return Play.effectiveCost(state, Play.probeItem(state, p, iid, origin), {});
    },

    playBlocked(state, p, iid, timing, verbose) {
      const o = state.objs[iid];
      if (!o) return "no such card";
      const origin = Play.playOrigin(state, p, iid);
      if (!origin) {
        return verbose
          ? nm(state, iid) + " is in your " + o.zone + ", and cards can only be played from your hand, your champion zone, a Hidden slot, or (for Flow spells) your trash"
          : "card is not playable from its zone";
      }
      if (o.owner !== p) return "not your card";
      const c = Core.card(state, iid);
      if (origin.fromZone === "facedown") {
        if (!origin.hiddenBf) return "facedown card lost";
        if (o.hiddenInfo && o.hiddenInfo.turn >= state.turn.num) {
          return "it was hidden this turn - from next turn it can be played like a Reaction, for free (rule 811.1.b)";
        }
        if (state.objs[origin.hiddenBf].controller !== p) {
          return verbose
            ? "you no longer control " + nm(state, origin.hiddenBf) + ", so the card you hid there cannot be revealed"
            : "you no longer control that battlefield";
        }
        const blocked = Core.unitsAt(state, { t: "bf", iid: origin.hiddenBf }, function (u) { return u.controller !== p; })
          .some(function (u2) { const sc2 = RB.Scripts.forCard(state, u2); return !!(sc2 && sc2.blockHiddenReveal); });
        if (blocked) return "an enemy unit prevents Hidden cards from being revealed here";
      }
      if (origin.fromZone === "trash") {
        const fsc = RB.Scripts.forCard(state, iid);
        const grantedFlow = Play.flowGrant(state, iid);
        const flow = grantedFlow ? grantedFlow.cost : (fsc && fsc.flowCost);
        if (!flow && !Play.trashPlayAllowed(state, p, iid)) return "only Flow spells can be played from the trash";
        if (flow) {
          if (!flow.allowNonSpell && !Core.isType(state, iid, "spell")) return "only Flow spells can be played from the trash";
          if (flow.cond && !RB.FX.evalCond(state, flow.cond, { iid: iid, p: p })) {
            return Core.name(state, iid) + " cannot be played from the trash right now";
          }
        }
      }
      if (Play.playRestricted(state, p, iid)) {
        return verbose
          ? "an effect in play forbids you from playing " + nm(state, iid) + " right now"
          : "an effect prevents you from playing that";
      }

      const kws = Core.keywords(state, iid);
      const ambushOk = !!kws.ambush && Core.isType(state, iid, "unit") && origin.fromZone === "hand" &&
        state.battlefields.some(function (b) {
          return Core.unitsAt(state, { t: "bf", iid: b }, function (u) { return u.controller === p; }).length > 0;
        });
      const hasReaction = !!kws.reaction || !!kws["quick-draw"] || origin.fromZone === "facedown" || ambushOk;
      const hasAction = !!kws.action || hasReaction;
      if (timing === "respond" && !hasReaction) {
        return verbose
          ? c.name + " has no [Reaction], and while something is on the chain only Reaction cards may be played - pass instead"
          : "only Reaction cards can be played on a chain";
      }
      if (timing === "focus" && !hasAction) {
        return verbose
          ? c.name + " has neither [Action] nor [Reaction], and only those may be played during a showdown - pass instead"
          : "only Action/Reaction cards can be played in a showdown";
      }

      if (!Play.requiredTargetsAvailable(state, p, iid, { fromFacedown: origin.fromZone === "facedown", hiddenBf: origin.hiddenBf })) {
        return verbose
          ? c.name + " must choose a target and there is nothing on the board it may legally choose"
          : c.name + " has no legal target";
      }
      if (!Play.mandatoryAddCostsPayable(state, p, iid, origin)) {
        return verbose
          ? "the additional cost " + c.name + " demands cannot be paid right now"
          : "its additional cost cannot be paid";
      }
      const cost = Play.playCost(state, p, iid, origin);
      const payCtx = Play.payCtxForCard(state, iid);
      if (!Play.poolPotentialCovers(state, p, cost, payCtx)) {
        return verbose
          ? c.name + " costs " + Play.costText(cost) + "; " + Play.shortfallText(state, p, cost, payCtx)
          : "cannot afford " + c.name;
      }
      return null;
    },

    abilityCost(state, iid, ab) {
      const cost = {
        energy: (ab.cost && ab.cost.energy) || 0,
        pips: [],
        anyPower: (ab.cost && ab.cost.anyPower) || 0,
      };
      if (ab.cost && ab.cost.pips) {
        for (let i = 0; i < ab.cost.pips; i++) {
          cost.pips.push(ab.cost.domains || (Core.card(state, iid).domains || null));
        }
      }
      const o = state.objs[iid];
      if (o && (o.zone === "board" || o.zone === "legendZone")) {
        for (const m of Play.abilityCostMods(state, iid, o.controller, ab)) {
          Play.applyCostMod(state, cost, m, iid, o.controller);
        }
      }
      return cost;
    },

    abilityBlocked(state, p, iid, ai, timing, verbose) {
      const o = state.objs[iid];
      if (!o || (o.zone !== "board" && o.zone !== "legendZone") || o.controller !== p) return "not your board object";
      const ab = RB.Scripts.abilitiesOf(state, iid)[ai];
      if (!ab) return "no scripted ability - use manual mode";
      const who = verbose ? (ab.label ? nm(state, iid) + "'s \"" + ab.label + "\"" : nm(state, iid) + "'s ability") : "";
      if (o.attachedTo && !ab.allowAttached) {
        return verbose ? nm(state, iid) + " is attached to another card, and attached cards cannot use abilities" : "attached cards cannot use this";
      }
      if (timing === "respond" && !ab.reaction) {
        return verbose ? who + " is not a Reaction, and while something is on the chain only Reactions may be used" : "ability is not a Reaction";
      }
      if (timing === "focus" && !ab.reaction && !ab.action) {
        return verbose ? who + " is neither an Action nor a Reaction, so it cannot be used during a showdown" : "ability lacks Action/Reaction";
      }
      if (ab.exhausts && !o.ready) {
        return verbose ? nm(state, iid) + " is exhausted, and " + who + " costs exhausting it" : "must be ready to use this";
      }
      if (ab.needBf && (!o.loc || o.loc.t !== "bf")) {
        return verbose ? nm(state, iid) + " is in your base, and " + who + " can only be used at a battlefield" : "usable only at a battlefield";
      }
      if (ab.spendBuffSelf && !(o.buffs > 0)) {
        return verbose ? nm(state, iid) + " has no buff counter to spend on " + who : "no buff to spend";
      }
      if (ab.oncePerTurn && o.flags["used" + ai] === state.turn.num) {
        return verbose ? who + " is once per turn and has already been used this turn" : "already used this turn";
      }
      if (ab.requiresNotEmpowered && (o.empowerCount || 0) >= (((RB.Scripts.forCard(state, iid) || {}).maxEmpower) || 1)) {
        return "already Empowered";
      }
      if (ab.requiresEmpowered && !o.empowered) return "must be Empowered to use this";
      if (ab.cond && !RB.FX.evalCond(state, ab.cond, { iid: iid, p: p })) return "ability's condition is not met";
      if (ab.disempowerSelf && !o.empowered) return "must be Empowered to use this";
      if (ab.requiresLegion && state.turnFacts.players[p].played < 1) {
        return verbose ? who + " needs [Legion] - play another card first this turn" : "no other card played this turn";
      }
      if (ab.requiresEquipmentPlayed && !state.turnFacts.players[p].equipmentPlayed) {
        return verbose ? who + " needs you to have played an Equipment this turn" : "no Equipment played this turn";
      }
      if (ab.costDiscard && !Play.canPayDiscard(state, p, ab.costDiscard, ab.costDiscardType)) {
        return verbose ? who + " costs discarding " + ab.costDiscard + " card" + (ab.costDiscard === 1 ? "" : "s") +
          (ab.costDiscardType ? " of type " + ab.costDiscardType : "") + " and your hand cannot pay that" : "cannot pay the discard cost";
      }
      if (ab.costKillFriendly && !Play.canPayKillFriendly(state, p)) {
        return verbose ? who + " costs killing one of your own units and you control none that can pay" : "no friendly unit to pay the cost";
      }
      if (ab.costRecycleTrash && state.players[p].trash.length < ab.costRecycleTrash) {
        return verbose ? who + " costs recycling " + ab.costRecycleTrash + " cards from your trash and you have only " +
          state.players[p].trash.length : "not enough cards in your trash";
      }
      if (ab.costXp && state.players[p].xp < ab.costXp) {
        return verbose ? who + " costs " + ab.costXp + " XP and you have " + state.players[p].xp : "not enough XP";
      }
      if (!Play.abilityTargetsAvailable(state, p, iid, ab)) {
        return verbose ? who + " must choose a target and there is nothing on the board it may legally choose" : "no legal target";
      }
      const abCost = Play.abilityCost(state, iid, ab);
      const abCtx = Play.payCtxForCard(state, iid);
      if (!Play.poolPotentialCovers(state, p, abCost, abCtx)) {
        return verbose ? who + " costs " + Play.costText(abCost) + "; " + Play.shortfallText(state, p, abCost, abCtx)
          : "cannot afford ability";
      }
      return null;
    },

    moveBlocked(state, p, units, dest, verbose) {
      if (!units || !units.length) return "no units to move";
      if (!dest) return "no destination";
      for (const iid of units) {
        const o = state.objs[iid];
        if (!o || o.zone !== "board" || o.controller !== p) return "not your board unit";
        if (!Core.isType(state, iid, "unit")) return "only units move";
        if (!o.ready) {
          return verbose ? nm(state, iid) + " is exhausted, and moving a unit costs exhausting it - it readies at the start of your next turn"
            : Core.name(state, iid) + " is exhausted";
        }
        if (o.attachedTo) return "attached cards cannot move";
        const from = o.loc;
        if (dest.t === "base") {
          if (dest.p !== p) return "units retreat to their own base";
          if (!from || from.t !== "bf") return verbose ? nm(state, iid) + " is already in your base" : "already in base";
          const fromScript = RB.Scripts.forCard(state, from.iid);
          if (fromScript && fromScript.noRetreat) return "units cannot move from " + Core.name(state, from.iid) + " to base";
        } else {
          if (state.battlefields.indexOf(dest.iid) < 0) return "bad battlefield";
          if (Core.sameLoc(from, dest)) return verbose ? nm(state, iid) + " is already at " + nm(state, dest.iid) : "already there";
          const destScript = RB.Scripts.forCard(state, dest.iid);
          const freeEntry = !!(destScript && destScript.allowMoveHere);
          if (from && from.t === "bf" && !freeEntry && !Core.hasKw(state, iid, "ganking")) {
            return verbose
              ? nm(state, iid) + " is already at " + nm(state, from.iid) + " and lacks [Ganking], so it cannot move straight to another battlefield - retreat to base first"
              : Core.name(state, iid) + " needs Ganking to move battlefield to battlefield";
          }
        }
        const why = Play.moveRestricted(state, p, iid, from, dest);
        if (why) return why;
      }
      const extra = Play.moveSurcharge(state, p, units, dest);
      if (extra > 0) {
        const cost = { energy: 0, pips: [], anyPower: extra };
        if (!Play.poolPotentialCovers(state, p, cost, {})) {
          return verbose
            ? "moving that many units there costs an extra " + extra + " power; " + Play.shortfallText(state, p, cost, {})
            : "cannot pay the extra " + extra + " power to move that many units there";
        }
      }
      return null;
    },

    moveDests(state, p, units) {
      const out = [];
      for (const bfIid of state.battlefields) {
        const dest = { t: "bf", iid: bfIid };
        if (!Play.moveBlocked(state, p, units, dest)) out.push(dest);
      }
      const base = { t: "base", p: p };
      if (!Play.moveBlocked(state, p, units, base)) out.push(base);
      return out;
    },

    hidePayable(state, p, cost) {
      if (Play.costFree(cost)) return true;
      return Play.poolCovers(state.players[p].pool, cost) || !!Play.autoPayPlan(state, p, cost);
    },

    hideBlocked(state, p, iid, bfIid, costIdx, verbose) {
      const o = state.objs[iid];
      if (!o || o.zone !== "hand" || state.players[p].hand.indexOf(iid) < 0) return "card must be in hand";
      if (!Core.hasKw(state, iid, "hidden")) {
        return verbose ? nm(state, iid) + " has no [Hidden], so it cannot be tucked under a battlefield" : "card has no Hidden keyword";
      }
      const bf = state.objs[bfIid];
      if (!bf || state.battlefields.indexOf(bfIid) < 0) return "bad battlefield";
      if (bf.controller !== p) {
        return verbose ? "you do not hold " + nm(state, bfIid) + ", and a card can only be hidden at a battlefield you control"
          : "you must control the battlefield";
      }
      if (!RB.Flow.hideSlotFree(state, bfIid)) {
        return verbose ? "you already have a card hidden at " + nm(state, bfIid) + ", and each battlefield holds one"
          : "a card is already hidden there";
      }
      const costs = Play.hideCosts(state, p);
      if (costIdx !== undefined && !costs[costIdx]) return "no such Hide cost";
      const wanted = costIdx === undefined ? costs : [costs[costIdx]];
      if (!wanted.some(function (c) { return Play.hidePayable(state, p, c); })) {
        return verbose
          ? "hiding costs " + Play.costText(wanted[0]) + "; " + Play.shortfallText(state, p, wanted[0], {})
          : "cannot pay the Hide cost";
      }
      return null;
    },

    playRestricted(state, p, iid) {
      const own = RB.Scripts.forCard(state, iid);
      if (own && own.playCond && !RB.FX.evalCond(state, own.playCond, { iid: iid, p: p })) return true;
      for (const f of state.fx) {
        if (f.k !== "restrictPlay" || f.player !== p) continue;
        if (f.banType) { if (Core.isType(state, iid, f.banType)) return true; continue; }
        if (!f.allowType) return true;
        if (!Core.isType(state, iid, f.allowType)) return true;
      }
      for (const s of Core.ruleSources(state, "restrictNamedSpell")) {
        const so = s.obj, nsr = s.rule;
        if (so.controller === p) continue;
        if (so.named && so.named.kind === "card" &&
          (!nsr.whileAtBf || (so.loc && so.loc.t === "bf")) &&
          (!nsr.type || Core.isType(state, iid, nsr.type)) &&
          Core.name(state, iid) === so.named.value) return true;
      }
      for (const s of Core.ruleSources(state, "auraRestrictPlay")) {
        if (s.obj.controller === p || !Core.auraScopeActive(s.obj, s.script)) continue;
        if (s.rule.allowType && !Core.isType(state, iid, s.rule.allowType)) return true;
      }
      return false;
    },

    playRestrictedToBase(state, p) {
      return Core.ruleSources(state, "auraRestrictPlay").some(function (s) {
        return s.obj.controller !== p && s.rule.toBaseOnly && Core.auraScopeActive(s.obj, s.script);
      });
    },

    nextPlayModsFor(state, p, iid, mod) {
      return state.nextPlayMods.filter(function (m) {
        return m.player === p && m.turn === state.turn.num && m.mod === mod &&
          (m.cardType === "any" || Core.isType(state, iid, m.cardType));
      });
    },

    consumeNextPlayMods(state, p, iid) {
      if (!state.nextPlayMods.length) return;
      state.nextPlayMods = state.nextPlayMods.filter(function (m) {
        if (m.persist) return true;
        return !(m.player === p && m.turn === state.turn.num &&
          (m.cardType === "any" || Core.isType(state, iid, m.cardType)));
      });
    },

    playLocations(state, item) {
      const p = item.controller;
      if (item.fromFacedown && item.hiddenBf) return [{ t: "bf", iid: item.hiddenBf }];

      if (item.opts && item.opts.timing && item.opts.timing !== "act" &&
        Core.hasKw(state, item.iid, "ambush") && !Core.hasKw(state, item.iid, "reaction")) {
        const ambushLocs = [];
        for (const bfIid of state.battlefields) {
          if (Core.unitsAt(state, { t: "bf", iid: bfIid }, function (u) { return u.controller === p; }).length) {
            ambushLocs.push({ t: "bf", iid: bfIid });
          }
        }
        if (ambushLocs.length) return ambushLocs;
      }
      if (Play.playRestrictedToBase(state, p)) return [{ t: "base", p: p }];
      const locs = [{ t: "base", p: p }];
      const script = RB.Scripts.forCard(state, item.iid);
      if (item.addCostBf && !locs.some(function (l) { return l.t === "bf" && l.iid === item.addCostBf.iid; })) {
        locs.push({ t: "bf", iid: item.addCostBf.iid });
      }
      const openBfGrant = RB.Scripts.anySource(state, "grantsPlayToOpenBf", { controller: p });
      for (const bfIid of state.battlefields) {
        const bf = state.objs[bfIid];
        if (bf.controller === p) locs.push({ t: "bf", iid: bfIid });
        else if (script && script.playToEnemyBf && Play.enemyBfAllowed(state, p, bfIid, script.playToEnemyBf)) {
          locs.push({ t: "bf", iid: bfIid });
        } else if (Core.isType(state, item.iid, "unit") && RB.Scripts.anySource(state, "grantsPlayToEnemyBf", {
          controller: p, test: function (rule) { return Play.enemyBfAllowed(state, p, bfIid, rule); },
        })) {
          locs.push({ t: "bf", iid: bfIid });
        } else if (openBfGrant && Core.isType(state, item.iid, "unit") &&
          !Core.unitsAt(state, { t: "bf", iid: bfIid }).length) {
          locs.push({ t: "bf", iid: bfIid });
        } else if (Core.hasKw(state, item.iid, "ambush")) {
          const mine = Core.unitsAt(state, { t: "bf", iid: bfIid }, function (o) { return o.controller === p; });
          if (mine.length) locs.push({ t: "bf", iid: bfIid });
        } else if (script && script.playToOpenBf) {
          if (!Core.unitsAt(state, { t: "bf", iid: bfIid }).length) locs.push({ t: "bf", iid: bfIid });
        }
      }
      const hereBf = item.opts && item.opts.hereBf;
      if (hereBf && state.battlefields.indexOf(hereBf) >= 0 &&
        !locs.some(function (l) { return l.t === "bf" && l.iid === hereBf; })) {
        locs.push({ t: "bf", iid: hereBf });
      }
      if (script && script.playToAttackedBf && state.showdown && state.showdown.combat &&
        state.showdown.attacker === p &&
        !locs.some(function (l) { return l.t === "bf" && l.iid === state.showdown.bf; })) {
        locs.push({ t: "bf", iid: state.showdown.bf });
      }
      const only = script && script.playOnlyTo;
      const seen = {};
      const anyBf = item.opts && item.opts.anyBf;
      const pool = anyBf
        ? state.battlefields.map(function (bfIid) { return { t: "bf", iid: bfIid }; })
        : locs;
      return pool.filter(function (l) {
        const key = l.t + ":" + (l.t === "bf" ? l.iid : l.p);
        if (seen[key]) return false;
        seen[key] = true;
        if (l.t === "bf" && Play.playHereBlocked(state, p, item.iid, l.iid)) return false;
        if (only) {
          if (l.t !== "bf") return false;
          if (only.conqueredThisTurn && (state.turn.conqueredBfs || {})[l.iid] !== p) return false;
          if (only.heldThisTurn && (state.turn.heldBfs || {})[l.iid] !== p) return false;
          if (only.controlled && state.objs[l.iid].controller !== p) return false;
        }
        return true;
      });
    },

    enemyBfAllowed(state, p, bfIid, rule) {
      const enemies = Core.unitsAt(state, { t: "bf", iid: bfIid }, function (u) { return u.controller !== p; });
      if (!enemies.length) return false;
      if (rule === true) return true;
      if (rule.enemyAlone) {
        const mine = Core.unitsAt(state, { t: "bf", iid: bfIid }, function (u) { return u.controller === p; });
        if (enemies.length !== 1 || mine.length) return false;
      }
      return true;
    },

    playHereBlocked(state, p, iid, bfIid) {
      const bs = RB.Scripts.forCard(state, bfIid);
      for (const r of (bs && bs.restrictPlayHere) || []) {
        if (!RB.Scripts.auraMatch(state, r, bfIid, state.objs[bfIid], iid, null, { p: p, loc: null, whoDefault: "all", condFor: "affected" })) continue;
        return true;
      }
      return false;
    },

    moveRestricted(state, p, iid, from, dest) {
      const mover = state.objs[iid];
      const stuck = (mover && mover.grants || []).find(function (g) { return g.k === "noMove"; });
      if (stuck) return stuck.reason || (Core.name(state, iid) + " cannot move this turn.");
      const srcs = Core.effectSources(state, { legends: false });
      const own = RB.Scripts.forCard(state, iid);
      const check = function (r, sIid) {
        const so = state.objs[sIid];
        if (r.self && sIid !== iid) return null;
        if (!RB.Scripts.auraMatch(state, r, sIid, so, iid, mover, { p: p, loc: from, whoDefault: "all" })) return null;
        if (!r.toBase && !r.toBf) return null;
        const hitsBase = r.toBase && dest.t === "base";
        const hitsBf = r.toBf && dest.t === "bf";
        if (!hitsBase && !hitsBf) return null;
        return r.reason || (Core.name(state, iid) + " cannot move there (" + Core.name(state, sIid) + ")");
      };
      for (const r of (own && own.restrictMove) || []) {
        const why = check(Object.assign({ self: true }, r), iid);
        if (why) return why;
      }
      for (const sIid of srcs) {
        if (sIid === iid) continue;
        const sc = RB.Scripts.forCard(state, sIid);
        for (const r of (sc && sc.restrictMove) || []) {
          if (r.self || !r.who) continue;
          const why = check(r, sIid);
          if (why) return why;
        }
      }
      return null;
    },

    moveSurcharge(state, p, units, dest) {
      if (!units || units.length < 2 || !dest || dest.t !== "bf") return 0;
      let n = 0;
      for (const s of Core.ruleSources(state, "moveTaxHere")) {
        const so = s.obj;
        if (so.controller === p || !(so.loc && so.loc.t === "bf" && so.loc.iid === dest.iid)) continue;
        n += (units.length - 1) * (s.rule.anyPower || 1);
      }
      return n;
    },

    scoreBlocked(state, p, bfIid) {
      const srcs = Core.effectSources(state, { legends: false });
      for (const sIid of srcs) {
        const so = state.objs[sIid];
        const sc = RB.Scripts.forCard(state, sIid);
        for (const r of (sc && sc.restrictScore) || []) {
          if (r.here && sIid !== bfIid) continue;
          if (!RB.Scripts.auraMatch(state, r, sIid, so, null, null, { p: p, loc: null, whoDefault: "all", condFor: "affected" })) continue;
          return r.reason || Core.name(state, sIid) + " prevents scoring";
        }
      }
      return null;
    },
  });
})();
